module.exports = __webpack_public_path__ + "static/media/logo-actual-star-wars.176edc7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-actual-star-wars.jpg
// module id = 28
// module chunks = 0